export function labelToId(str: string) {
  return str.toLowerCase().replace(/ /g, "-");
}
